import { Visualizer } from '@uirouter/visualizer'

export function routerDebugRun ($uiRouter, $trace) {
  'ngInject'

  // Sikker check for development environment
  const isDevelopment = typeof process !== 'undefined' &&
    process.env &&
    process.env.NODE_ENV === 'development'

  const isDebugEnabled = typeof process !== 'undefined' &&
    process.env &&
    process.env.DEBUG_UIROUTER === true

  if (isDevelopment && isDebugEnabled) {
    // Enable state visualizer
    $uiRouter.plugin(Visualizer)

    // Enable transition tracing
    $trace.enable('TRANSITION')
  }
}
